/**
 * Created by svitlana.i on 10/10/2017.
 */
import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { OrderService } from "../../services/orderService";
import { Order } from "../../objects/orders/order";
import { PaginationInstance } from "ngx-pagination";
import { OrderSearch } from "../../objects/responses/orderSearch";
import { UserService } from "../../services/userService";
import { CustomerService } from "../../services/customerService";
import { BaseOrderManagement } from "../Managment/orderManagement/baseOrderManagement";
import { Location } from '@angular/common';
import { TotalFeeResponse } from "../../objects/report/totalFeeResponse";
import { ChartsHelper } from "../../common/helpers/chartsHelper";
import { StorageManager } from "../../common/managers/storageManager";
import { UserViewOrderResolver } from "../userView/user-view-order.resolver";
import { UserViewService } from "../../services/userViewService";
import { OrderODataService } from "../../services/orderOData.service";
import { Component as ComponentEnum } from "../../objects/components/component";
import { OrderViewType } from "../../objects/management/order/orderViewType";


@Component({
    selector: "dashboard",
    templateUrl: "./dashboard.component.html",
    moduleId: module.id.toString()
})

export class DashboardComponent extends BaseOrderManagement implements OnInit {

    public stringLink = String;

    public query: string = "";

    public totalFees: Array<TotalFeeResponse> = [];

    public totalQuantity: Array<TotalFeeResponse> = [];

    constructor(private route: ActivatedRoute, public orderService: OrderService, public location: Location, public customerService: CustomerService
        , public userService: UserService, private router: Router, public storageManager: StorageManager, public userViewService: UserViewService, public orderODataService: OrderODataService) {
        super(orderService, location, customerService, userService, storageManager, userViewService, orderODataService);
    }

    public ngOnInit(): void {
        this.config.totalItems = this.route.snapshot.data.userViewOrder.orders.TotalCount;
        this.orders = this.route.snapshot.data.userViewOrder.orders.Items;
        this.totalFees = this.route.snapshot.data.totalFee;
        this.totalQuantity = this.route.snapshot.data.totalQuantity;

        let beginDate: Date = new Date((new Date()).setDate(new Date().getDate() - 7), 0, 0, 0);
        let endDate = new Date();

        ChartsHelper.convertAndCutDate(this.totalFees, beginDate, endDate);
        ChartsHelper.convertAndCutDate(this.totalQuantity, beginDate, endDate);

        this.tableColumns = this.getColumns(OrderViewType.Tile);
    }

    public goToSearch(): void {
        this.router.navigate(['/management/order', { query: this.query }])
    }



}


// WEBPACK FOOTER //
// ./app/components/dashboard/dashboard.component.ts